module.exports = __webpack_public_path__ + "img/microsilver_mouthSpray.a91c3165.jpg";